namespace TR {
    class ChildDestinationFilter {

        model: any;
        aggregate: any;
        limit: any;
        showAll: boolean;
        destArray: any;
        people: any;

        constructor($scope: ng.IScope,
                    occupancyService: Core.OccupancyService) {
            $scope.$watch('cd.aggregate', agg => {
                if (!agg) { return; }

                const destArray:any = [];
                for (let key in agg) {
                    destArray.push(_.extend(agg[key], { id: key }));
                }
                const min:any = _.minBy(destArray, (v:any) => v.MinPrice);
                if (min) { min.cheapest = true; }
                this.model = _.filter(this.model, d => _.has(agg, d));
                this.destArray = destArray;
                this.people = occupancyService.getNumberOfNonInfantPassengers();
            });
        }

        isSet() {
            return !!_.size(this.model);
        }

        reset() {
            this.model = [];
        }

        more(all: boolean) {
            this.showAll = all;
        }

        showMoreLess() {
            return Object.keys(this.aggregate || {}).length > this.limit;
        }
    }

    angular
        .module('TR')
        .directive('childDestinationFilter', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=ChildDestinationFilter',
                bindToController: {
                    aggregate: '=',
                    model: '=',
                    limit: '@',
                    priceMode: '='
                },
                controller: ChildDestinationFilter,
                controllerAs: 'cd'
            };
        });

    class ChildDestinationFilterLabel {

        public static getTemplate() {
            return `
                <span ng-if="cd.isSet()">
                    <a
                        href="#"
                        ng-repeat="dest in cd.model"
                        class="filter-criterion-toggle"
                        ng-click="cd.remove(dest)">
                        <span> {{cd.getName(dest)}} </span>
                    </a>
                </span>
            `;
        }

        model: any;
        aggregate: any;

        constructor($scope: ng.IScope, analytics: any) {
            $scope.$watch('cd.model', (value: any) => {
                if (!value || !value.length) { return; }
                let destinations = value.map(v => this.getName(v));
                analytics.track(
                    'mixpanel',
                    'HolidayDealsFilterDestinations',
                    { value: destinations }
                );
            });
        }

        getName(dest) {
            if (!this.aggregate) { return ''; }
            return (this.aggregate[dest] || {}).Title;
        }

        isSet() {
            return !!_.size(this.model);
        }

        remove(dest) {
            this.model = this.model.filter(v => v !== dest);
        }
    }

    angular
        .module('TR')
        .directive('childDestinationFilterLabel', (): ng.IDirective => {
            return {
                scope: {},
                template: ChildDestinationFilterLabel.getTemplate(),
                bindToController: {
                    aggregate: '=',
                    model: '='
                },
                controller: ChildDestinationFilterLabel,
                controllerAs: 'cd'
            };
        });

}
